/**
 * @generated SignedSource<<0b5122ea1e88133597933196e4042d0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightSidebarPackages_flight$data = {
  readonly packages: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "FlightSidebarPackages_flight";
};
export type FlightSidebarPackages_flight$key = {
  readonly " $data"?: FlightSidebarPackages_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightSidebarPackages_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightSidebarPackages_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Package",
      "kind": "LinkedField",
      "name": "packages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "1d4d4830318b2cfbb3fa57748e530c1a";

export default node;
